import { environment } from '../../../environments/environment';

export const TIME_FORMAT_V2_ROUTES: string[] = [
  'GET /notifications',
  'GET /alarms',
  'GET /caregivers/{id}/alarms',
  'GET /traits',
  'GET /alarms/stats',
  'GET /chat/conversations/{peerId}/messages',
  'POST /chat/conversations/{peerId}/messages',
  'POST /chat/conversations/{peerId}/attachments',
  'GET /patients/ranked',
  'GET /caregivers/{id}/patients',
  'GET /reports/work-history',
  'GET /reports/imei-changes',
  'GET /reports/band-history',
  'GET /caregivers',
  'GET /user/mfa/status',
  'GET /user/mfa/admin/{imei}/status',
  'GET /user/mfa/devices',
  'POST /user/mfa/enroll/{channel}/init',
  'POST /user/mfa/challenge',
  'POST /user/login',
  'POST /user/login/mfa/resend',
  'POST /user/login/mfa/verify',
  'GET /user/fcm-notification-settings',
  'PATCH /user/fcm-notification-settings',
  'GET /admin/reach-instructions',
  'POST /admin/reach-instructions',
  'PUT /admin/reach-instructions/{id}',
  'GET /admin/voip/topology',
  'GET /manager/ai/patient-summary/{imei}',
  'POST /manager/ai/patient-summary/{imei}/regenerate',
  'GET /caregiver/ai/patient-summary/{imei}',
  'POST /caregiver/ai/patient-summary/{imei}/regenerate',
  'POST /manager/ai/patient-query/{imei}',
  'POST /caregiver/ai/patient-query/{imei}',
  'GET /manager/reach/agents',
  'POST /manager/reach/agents',
  'GET /manager/reach/agents/{id}',
  'PUT /manager/reach/agents/{id}',
  'GET /manager/reach/phone-numbers',
  'GET /voip/sms/history',
  'GET /voip/sms/patient/{patientId}',
  'GET /voip/sms/unread',
  'GET /voip/sms/conversation/{phoneNumber}',
  'GET /manager/voip/local-call-logs',
  'GET /manager/voip/local-call-stats',
  'GET /manager/voip/session-logs',
  'GET /manager/voip/session-stats',
  'GET /caregiver/voip/recent-calls',
  'GET /manager/reach/call-logs',
  'GET /manager/reach/call-logs/{id}',
  'GET /manager/reach/call-stats',
  'GET /manager/reach/export-csv',
  'GET /manager/voip/workstations',
  'GET /manager/voip/my-session',
  'GET /caregiver/voip/my-session',
  'GET /manager/voip/paramedic-sip-accounts',
  'GET /manager/voip/find-patient-by-phone',
  'GET /caregiver/voip/find-patient-by-phone',
  'GET /caregiver/voip/desk-call',
  'GET /caregiver/voip/transcription/{recordingId}',
  'POST /manager/voip/transcribe/{recordingId}',
  'POST /caregiver/voip/transcribe/{recordingId}',
  'POST /manager/voip/auto-transcribe',
  'POST /caregiver/voip/auto-transcribe',
  'GET /manager/getDataOfManager',
  'GET /manager/getDataOfCaregiver',
  'GET /manager/getLastNotifsNormal',
  'GET /caregiver/getLastNotifsNormalCaregiver',
  'GET /manager/getLastNotifsTraits',
  'GET /caregiver/getLastNotifsTraitsCaregiver',
  'GET /patient/getLastNotifs/{imei}',
  'GET /manager/getNotifsWithConnected',
  'GET /getSidenavNotifs',
  'GET /manager/getUserOfMapLocal/{imei}',
  'GET /manager/getUsersOfMapLocal',
  'GET /caregiver/getUsersOfMapLocal',
  'GET /manager/getLastLocations/{number}/{imei}',
  'GET /user/responderState',
  'GET /manager/getAllBands',
  'GET /alarm/getListOfResponders/{imei}',
  'GET /alarm/getListOfRespondersBasic/{imei}',
  'GET /alarm/getStatusesFromAlarm/{alarm_id}',
  'GET /get-beacons',
  'GET /get-beacon/{id}',
  'GET /getBeacon/mac/{mac}',
  'GET /patient/{imei}/alarm/fall',
  'GET /patient/{imei}/alarm/sos',
  'GET /patient/{imei}/alarm/zone',
  'GET /patient/{imei}/alarm/immo',
  'GET /patient/{imei}/all',
  'GET /patient/{imei}/alarmEBS/{type}',
  'GET /getAllAlarmsNotHandled/{imei}',
  'GET /patient/{imei}/alarms/recent',
  'GET /patient/{imei}/water-intake',
  'GET /patient/{imei}/pressure',
  'GET /alarm/preview/{imei}',
  'GET /alarm/details/{id}',
  'GET /alarm/meas/{id}',
  'GET /patient/myShortInfo',
  'GET /patientIntegrate/{imei}',
  'GET /patientIntegrateAlarm/{imei}',
  'GET /user/me',
  'GET /user/showCaregiver',
  'GET /user/showCaregiver/{id}',
  'GET /user/showObserver/{id}',
  'DELETE /manager/remove-patient-from-caregiver',
  'GET /getHours/{imei}',
  'GET /getDocuments/{imei}/{termsNeed}',
  'GET /fallprediction/{imei}'
];

export type TimeFormatMismatch = 'not-migrated' | 'not-opted-in';

export function routeMatches(route: string, method: string, url: string): boolean {
  const [routeMethod, routePath] = route.split(' ');
  if (routeMethod.toUpperCase() !== method.toUpperCase() || !url.startsWith(environment.api_url)) {
    return false;
  }
  const path = url.slice(environment.api_url.length).split('?')[0];
  const pattern = routePath
    .split(/(\{[^}]+\})/)
    .map(part => /^\{[^}]+\}$/.test(part) ? '[^/]+' : part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('');
  return new RegExp(`^${pattern}$`).test(path);
}

export function requestsTimeFormatV2(method: string, url: string): boolean {
  return TIME_FORMAT_V2_ROUTES.some(route => routeMatches(route, method, url));
}

export function timeFormatMismatch(requested: boolean, served: string | null): TimeFormatMismatch | null {
  if (requested) {
    return served === '2' ? null : 'not-migrated';
  }
  return served === '1' ? 'not-opted-in' : null;
}
